import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface CodeType {
	commCdId: string;
	commCdNm: string;
	commCdExpl: string;
	commCdOrder: string;
	commCdAttr1: string;
	commCdExpl1: string;
	commCdAttr2: string;
	commCdExpl2: string;
	commCdAttr3: string;
	commCdExpl3: string;
	commCdAttr4: string;
	commCdExpl4: string;
	commCdAttr5: string;
	commCdExpl5: string;
	commCdAttr6: string;
	commCdExpl6: string;
	commCdAttr7: string;
	commCdExpl7: string;
	commCdAttr8: string;
	commCdExpl8: string;
}

/** ```
 * 공통 코드 조회
 *   `/esntl/api/code/${groupId}`
 * parameter
 *   `groupId` 그롭 ID
 * ```*/
const key = `useCode`;
const getPath = (groupId: string): string | null => {
	if (!groupId) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/common/code/${groupId}`;
};

/** ```
 * 공통 코드 조회
 *   `/esntl/api/code/${groupId}`
 * parameter
 *   `groupId` 그롭 ID
 * ```*/
const useCode = (groupId: string, options?: Partial<UseQueryOptions<Response<CodeType[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(groupId)],
		queryFn: () => useConfigureAxios({url: getPath(groupId)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		...options,
	});

export default useCode;
export {getPath, key};
export type {CodeType};
